import React from 'react';
import classNames from 'classnames';
import styles from './index.module.less';

const GlobalFooter = ({ className, links, copyright }) => {
  const clsString = classNames(styles.globalFooter, className);

  return (
    <footer className={clsString}>
      {copyright && <div className={styles.copyright}>{copyright}</div>}
    </footer>
  );
};

export default GlobalFooter;
